/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I mix units?`)
};

const es_pctsol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo combinar unidades?`)
};

const de_pctsol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich Einheiten mischen?`)
};

const nl_pctsol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik eenheden combineren?`)
};

const fr_pctsol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je mélanger les unités ?`)
};

const it_pctsol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso combinare le unità?`)
};

const pt_br2_pctsol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso misturar unidades?`)
};

const pt_pctsol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso misturar unidades?`)
};

const ja_pctsol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単位を混在させることはできますか？`)
};

const zh_pctsol_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以混用单位吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_faq_q3", locale)
	if (locale === "en") return en_pctsol_faq_q3(inputs)
	if (locale === "es") return es_pctsol_faq_q3(inputs)
	if (locale === "de") return de_pctsol_faq_q3(inputs)
	if (locale === "nl") return nl_pctsol_faq_q3(inputs)
	if (locale === "fr") return fr_pctsol_faq_q3(inputs)
	if (locale === "it") return it_pctsol_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_faq_q3(inputs)
	if (locale === "pt") return pt_pctsol_faq_q3(inputs)
	if (locale === "ja") return ja_pctsol_faq_q3(inputs)
	return zh_pctsol_faq_q3(inputs)
};